import React from 'react';
import LcAccordion from '../../../../../components/Generic/LcAccordion';
import "./index.css";

interface Props {
    closing: boolean,
    handleCloseSolicitation: Function
}

const SolicitationDetailsClosing: React.FC<Props> = (props) => {
    return (
        <>
            {
                props.closing &&
                <div className={'divOrderDetailsClosing'}>
                    <LcAccordion title={"Confirmar encerramento"} visible={true} iconNormal={true} >
                        <button type={'button'} className={"lc-button bg-info"} onClick={() => props.handleCloseSolicitation()} style={{ width: "100px" }}> Encerrar </button>
                    </LcAccordion>
                </div>
            }
        </>
    );
};

export default SolicitationDetailsClosing;